module.exports = {"schedule":{"title":"Agenda","now_playing":"En curso","empty":{"title":"Nada encontrado","detail":"No hay próximos elementos para mostrar"}}}